export const SHOW_COMPARE = 'SHOW_COMPARE';
export const ADD_COMPARE = 'ADD_COMPARE';
export const REMOVE_COMPARE = 'REMOVE_COMPARE';
export const CLEAN_COMPARE = 'CLEAN_COMPARE';

export function showCompare(item) {
  return {
    type: SHOW_COMPARE,
    payload: item,
  };
}

export function addCompare(item) {
  return {
    type: ADD_COMPARE,
    payload: item,
  };
}

export function removeCompare(item) {
  return {
    type: REMOVE_COMPARE,
    payload: item,
  };
}

export function cleanCompare(item) {
  return {
    type: CLEAN_COMPARE,
    payload: item,
  };
}
